module.exports = __webpack_public_path__ + "img/footer-resvana.01747f0b.png";